/** Helpers de pago online vs cobrar en caja (sin I/O). */

export function isMercadoPagoPaidOrder(order: {
  payment_provider: string | null;
  payment_status: string | null;
}): boolean {
  return order.payment_provider === 'mercadopago' && order.payment_status === 'paid';
}

/** Paga al retirar / cobro en local — payment_provider null (no MP). */
export function isPayAtPickupOrder(order: { payment_provider: string | null }): boolean {
  return order.payment_provider !== 'mercadopago';
}

/**
 * Gate solo en la acción final que asienta efectivo (picked_up).
 * Si el pedido ya figura pagado, no exige caja (p.ej. MP mal etiquetado o cobro previo).
 */
export function needsCashSessionToComplete(
  order: { payment_provider: string | null; payment_status: string | null },
  nextStatus: string | null,
): boolean {
  if (nextStatus !== 'picked_up') return false;
  if (!isPayAtPickupOrder(order)) return false;
  if (order.payment_status === 'paid' || order.payment_status === 'refunded') return false;
  return true;
}
